<template>
  <div>
    <div class="theater-message-wrapper">
      <div class="videoParts_wrapper">
        <div class="videoParts_inner" :class="{'p-positionCenter': conference.display_chat}">
          <div class="videoPlayer">
            <div class="videoPlayer_wrapper" :class="{'no-mask': conference.video_content_id, 'no-playbtn': conference.video_content_id}">
              <YouTubeManager v-if="isYouTubeConference" :video-content-id="conference.video_content_id" :play-video="playingVideo" />
              <VimeoManager
                v-if="isVimeoConference"
                :video-content-id="conference.video_content_id"
                :play-video="playingVideo"
                :questionnaire-settings="conference.questionnaire_settings"
                :disable-start-button-questionnaire-ids="conference.questionnaires.map(questionnaire => questionnaire.id)"
                :slug="conference.slug"
              />
              <JStreamManager v-if="isJStreamConference" :video-content-id="conference.video_content_id" :play-video="playingVideo" />
              <VimeoManager
                v-if="isVimeoLiveConference"
                :video-content-id="conference.video_content_id"
                :is-live="true"
                :play-video="playingVideo"
                :questionnaire-settings="conference.questionnaire_settings"
                :disable-start-button-questionnaire-ids="conference.questionnaires.map(questionnaire => questionnaire.id)"
                :slug="conference.slug"
                :start-at="conference.video_start_at"
              />
              <div v-if="hasNoContent" class="player"></div>
              <Thumbnail
                v-if="showThumbnail"
                :page="conference"
                @play-video="playVideo"
                :style="{cursor: conference.video_content_id === null ? 'initial' : 'pointer'}"
              />
            </div>
          </div>
        </div>
        <!-- videoParts_inner -->
      </div>
      <RoomMessageColumn v-if="conference.display_chat" :room-name="conference.name" />
    </div>
    <!-- /videoParts_wrapper -->
    <div class="videoTitle_wrapper wrapper hard">
      <div class="videoTitle_inner flex_center">
        <div class="flex_center videoTitle_content">
          <div class="extBtn_wrapper" v-if="isRoom">
            <router-link
              :to="{name: 'Hall', params: {slug: $store.getters['event/slug'], hallSlug: conference.slug}}"
              class="ext_btn flex_center inner light btn"
            >
              <fa-icon icon="sign-out-alt" />
              <span>退出する</span>
            </router-link>
          </div>
          <h2 class="videoTitle inner light">
            <span>{{ conference.name }}</span>
          </h2>
        </div>
        <div class="flex_center videoInfo_content">
          <div class="videoinfoItem_wrapper flex_center">
            <PersonsCount
              v-if="conference.has_self_room && conference.max_join_count"
              :hall-slug="conference.slug"
              :room-slug="'hall_room'"
              :gte-max-join-count="gteMaxJoinCount(conference.slug, 'hall_room', conference.max_join_count)"
              :max-join-count="conference.max_join_count"
            />
            <div class="time_parts" v-if="conference.video_duration">
              <span>{{ conference.video_duration }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="videoTxt_wrapper wrapper background">
        <p><RawHtml :text="conference.description" /></p>
      </div>
      <Participants v-if="participants.length" :participants="participants" />
    </div>
  </div>
</template>

<script>
import PersonsCount from "../elements/PersonsCount"
import Participants from "../elements/Participants"
import Thumbnail from "../elements/Thumbnail"
import RawHtml from "../elements/RawHtml"
import RoomMessageColumn from "./RoomMessageColumn"
import JStreamManager from "./JStreamManager"
import YouTubeManager from "./YouTubeManager"
import VimeoManager from "./VimeoManager"

export default {
  name: "Conference",
  components: {
    RoomMessageColumn,
    Participants,
    PersonsCount,
    Thumbnail,
    RawHtml,
    JStreamManager,
    YouTubeManager,
    VimeoManager
  },
  props: {
    conference: {
      type: Object,
      required: true
    },
    isRoom: {
      type: Boolean,
      required: true
    }
  },
  beforeRouteUpdate(to, from, next) {
    this.playingVideo = false
    next()
  },
  data() {
    return {
      showThumbnail: true,
      playingVideo: false,
      youtube: 1,
      vimeo: 2,
      jStream: 3
    }
  },
  computed: {
    isYouTubeConference() {
      if (_.isEmpty(this.conference.video_content_id)) return false

      return this.conference.video_service_type === 1
    },
    isVimeoConference() {
      if (_.isEmpty(this.conference.video_content_id)) return false

      return this.conference.video_service_type === 2
    },
    isJStreamConference() {
      if (_.isEmpty(this.conference.video_content_id)) return false

      return this.conference.video_service_type === 3
    },
    isVimeoLiveConference() {
      if (_.isEmpty(this.conference.video_content_id)) return false

      return this.conference.video_service_type === 4
    },
    hasNoContent() {
      return _.isNull(this.conference.video_content_id)
    },
    participants() {
      return this.$store.getters["participants/getByHallAndRoomSlug"](this.conference.slug, null)
    },
    gteMaxJoinCount: vm => (hallSlug, roomSlug, maxJoinCount) => {
      if (maxJoinCount === null) return false

      return vm.$store.getters["participants/countByHallAndRoomSlug"](hallSlug, roomSlug) >= maxJoinCount
    }
  },
  methods: {
    playVideo() {
      if (this.hasNoContent) return

      this.showThumbnail = false

      this.$axios
        .post(`events/${this.$route.params.slug}/action_logs`, {
          type: 1, // Enums\ActionLog\Type::VIDEO
          whereable_id: this.conference.id,
          whereable_type: "halls",
          url: this.$route.path
        })
        .then(response => {
          return true
        })
        .catch(error => {
          console.log(error.response.data.message)
        })

      this.playingVideo = true
    }
  }
}
</script>
